<div class="text-end mb-3">
  <button
    type="button"
    class="btn btn-success"
    (click)="exportExcel()"
    [disabled]="!hasData()"
    data-bs-toggle="tooltip"
    data-bs-placement="top"
    title="Exporta los datos a un archivo de Excel">
    <i class="bi bi-file-earmark-excel me-1"></i>
    Exportar Excel
  </button>
</div>
